// @ts-nocheck
import React from 'react';
import PddTestResultCard from './../pdd/Results/Card';
export default ({
  driverId,
  pddTestResultId
}) => {
  const breadCrumbs = [{
    to: '/',
    name: 'Главная'
  }, {
    to: '/admin/drivers',
    name: 'Водители'
  }, {
    to: `/admin/drivers/${driverId}`,
    name: 'Карточка водителя'
  }, {
    name: 'Просмотр теста'
  }];
  return <PddTestResultCard id={pddTestResultId} breadCrumbs={breadCrumbs} />;
};
